export const randomElement = (array: any[]) =>
  array[Math.floor(Math.random() * array.length)];